import { publicRequest } from "@/services";
import { Flex, Typography } from "antd";
import _ from "lodash";
import React, { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const onRequestVerifiedCode = async (code: string, email: string) => {
  try {
    const result = await  publicRequest<any, any>({
      url: `/email-qr-verified?code=${code}&email=${email}`,
      method: "POST",
    });

    console.log("/email-qr-verified")
    console.log(result)
    return result.data
  } catch (error) {
    console.log(error);
  }
};

const LoginQREmail: React.FC = () => {
  const queryString = new URLSearchParams(window.location.search);

  const code = _.defaultTo(queryString.get("code"), "");
  const email = _.defaultTo(queryString.get("email"), "");

  const navigate = useNavigate();

  const onVerify = useCallback(async () => {
    const result = await onRequestVerifiedCode(code, email);
    await localStorage.setItem("access_token", result["token"] ?? "");
  
    console.log(result["token"])
    navigate("/admin", { replace: true });}, [code, email]);

  useEffect(() => {
    onVerify();
  }, []);

  return (
    <Flex gap="middle" align="center" vertical>
      <Typography.Text style={{ fontSize: 24, color: "#40C1A2" }}>
        Verifying...
      </Typography.Text>
    </Flex>
  );
};

export default LoginQREmail;
